var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"to-header",class:{ secure: _vm.toSpecialist }},[(!_vm.toSpecialist)?_c('div',{staticClass:"to-header__secure"},[_c('div',{staticClass:"to-header__secure-button button-main",on:{"click":function($event){$event.stopPropagation();return _vm.secureOrder.apply(null, arguments)}}},[_vm._v(" Взять этот заказ ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }